import { Button } from '@material-ui/core';

import React from 'react';
import { auth, provider } from '../Firebase';
import './Login.css';
import img from './Images/whatsApp.png';
import { useStateValue } from './StateProvider';
import { actionTypes } from '../reducer';

function Login() {
    const [{},dispatch] = useStateValue();


    const signIn = () => {
        auth
        .signInWithPopup(provider)
        .then((result)=>{
            dispatch ({
                type:actionTypes.SET_USER,
                user: result.user,
            });
        })
        .catch((error)=>alert(error.message));
        
    };
    return (
        <div className="login">
            <div className="login__container">
                <img src={img} alt=""/>
                <div className="login__text">
                    <h1>
                        Sign in to WhatsApp
                    </h1>
                </div>
                <Button onClick={signIn}>
                    Sign In With Google
                </Button>

            </div>
        </div>
    )
}

export default Login
